<template>
    <div class="message_search_popup_main" id="message_search_id">
        <div class="message_search_modal">
            <div class="message_search_modal_header">
                <h3 class="message_search_modal_heading">
                    Search in Conversation: {{ conversationName }}
                </h3>
                <div class="message_searchbar" :class="{ active: searchMessageActionState }">
                    <input type="text" class="form-control" v-model.trim="search_term" v-focus>
                    <span class="search_icon" v-if="!searchMessageActionState">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                            <path fill="#ffffff"
                                d="M15.009 13.805h-.636l-.22-.219a5.184 5.184 0 0 0 1.256-3.386 5.207 5.207 0 1 0-5.207 5.208 5.183 5.183 0 0 0 3.385-1.255l.221.22v.635l4.004 3.999 1.194-1.195-3.997-4.007zm-4.808 0a3.605 3.605 0 1 1 0-7.21 3.605 3.605 0 0 1 0 7.21z">
                            </path>
                        </svg>
                    </span>
                    <span class="back_icon" v-if="searchMessageActionState">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                            @click="clearSearchTermAction">
                            <path fill="#ffd400" d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8 8-8z"></path>
                        </svg>
                    </span>
                    <span class="x-alt" v-if="search_term.length >= 1">
                        <svg height="15px" viewBox="0 0 329.26933 329" width="15px" xmlns="http://www.w3.org/2000/svg"
                            @click="clearSearchTermAction">
                            <g fill="#f44336">
                                <path
                                    d="m21.339844 329.398438c-5.460938 0-10.925782-2.089844-15.082032-6.25-8.34375-8.339844-8.34375-21.824219 0-30.164063l286.589844-286.59375c8.339844-8.339844 21.824219-8.339844 30.164063 0 8.34375 8.339844 8.34375 21.824219 0 30.164063l-286.589844 286.59375c-4.183594 4.179687-9.621094 6.25-15.082031 6.25zm0 0">
                                </path>
                                <path
                                    d="m307.929688 329.398438c-5.460938 0-10.921876-2.089844-15.082032-6.25l-286.589844-286.59375c-8.34375-8.339844-8.34375-21.824219 0-30.164063 8.339844-8.339844 21.820313-8.339844 30.164063 0l286.589844 286.59375c8.34375 8.339844 8.34375 21.824219 0 30.164063-4.160157 4.179687-9.621094 6.25-15.082031 6.25zm0 0">
                                </path>
                            </g>
                        </svg>
                    </span>
                </div>
                <span class="close_modal_search">
                    <i class="fa fa-times-circle-o" aria-hidden="true" @click="searchMessagePopupCloseMethod"></i>
                </span>
            </div>
            <div class="message_search_modal_body mt-2" v-if="searchMessageActionState">
                <div class="searched_message_list">
                    <ul class="message_list_items" v-if="searchMessageResults.length > 0">
                        <li class="message_list_item" v-for="item in searchMessageResults" :key="item.id">
                            <div class="message_list_item_inner" :class="getMessagePosition(item)">
                                <span class="message_sender_name" :style="{ color: item.sender && item.sender.colour }">
                                    {{ item.sender.first_name }} {{ item.sender.last_name }}
                                </span>
                                <span class="mesg_text d-block" v-html="item.message"></span>
                                <span class="msg_time d-block">{{ item.timestamp | dateformat }} at {{ item.timestamp |
                                    chattimeformat }}</span>
                                <span class="msg_for_action">
                                    <span class="dropdown">
                                        <span class="action_toggle_option" data-toggle="dropdown">
                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                        <ul class="dropdown-menu">
                                            <li @click="replyOnMessageViewOpenMethod(item)">Reply</li>
                                            <li @click="forwardMsgToUserMethod(item)">Forward Message</li>
                                        </ul>
                                    </span>
                                </span>
                            </div>
                        </li>
                    </ul>
                    <p class="mt-5 mb-0 text-center" style="font-size:16px;color:#545454;" v-else>No messages found</p>
                </div>
                <div class="rply_textbox_wrp" v-if="replyOnMessageBoxState">
                    <div class="reply_msg_detail_view_wrp">
                        <div class="row align-items-center">
                            <div class="col-sm-11 pr-sm-0">
                                <div class="reply_msg_data_wrp" v-if="replyOnMessageData">
                                    <div class="reply_msg_send_status">
                                        <div class="reply_msg_un">
                                            <span class="message_sender_name">{{ replyOnMessageData.sender.first_name }}
                                                {{ replyOnMessageData.sender.last_name }}</span>
                                        </div>
                                        <div class="reply_msg_txt">
                                            <template v-if="replyOnMessageData.forwarded">
                                                <span class="chat_msg_content_show"
                                                    v-if="replyOnMessageData.forwarded_from.message"
                                                    v-html="replyOnMessageData.forwarded_from.message">
                                                </span>
                                                <span class="show_msg_of_reply_txt"
                                                    v-else-if="replyOnMessageData.forwarded_from.file">
                                                    <a :href="replyOnMessageData.forwarded_from.file" target="_new">{{
                                                        getFileName(replyOnMessageData.forwarded_from.file) }}</a>
                                                </span>
                                            </template>
                                            <span class="chat_msg_content_show" v-else-if="replyOnMessageData.message"
                                                v-html="replyOnMessageData.message"></span>
                                            <span class="show_msg_of_reply_txt" v-else>
                                                <a :href="replyOnMessageData.file" target="_new">{{
                                                    getFileName(replyOnMessageData.file) }}</a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 ml-auto">
                                <span class="reply_msg_data_close">
                                    <span class="x-alt">
                                        <svg height="15px" viewBox="0 0 329.26933 329" width="15px"
                                            xmlns="http://www.w3.org/2000/svg" @click="replyOnMessageViewClosedMethod">
                                            <g fill="#f44336">
                                                <path
                                                    d="m21.339844 329.398438c-5.460938 0-10.925782-2.089844-15.082032-6.25-8.34375-8.339844-8.34375-21.824219 0-30.164063l286.589844-286.59375c8.339844-8.339844 21.824219-8.339844 30.164063 0 8.34375 8.339844 8.34375 21.824219 0 30.164063l-286.589844 286.59375c-4.183594 4.179687-9.621094 6.25-15.082031 6.25zm0 0">
                                                </path>
                                                <path
                                                    d="m307.929688 329.398438c-5.460938 0-10.921876-2.089844-15.082032-6.25l-286.589844-286.59375c-8.34375-8.339844-8.34375-21.824219 0-30.164063 8.339844-8.339844 21.820313-8.339844 30.164063 0l286.589844 286.59375c8.34375 8.339844 8.34375 21.824219 0 30.164063-4.160157 4.179687-9.621094 6.25-15.082031 6.25zm0 0">
                                                </path>
                                            </g>
                                        </svg>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-1">
                        <div class="col pr-0">
                            <textarea type="text" class="form-control" v-model="sendMessageTxt"
                                placeholder="Type a message..." @keydown.enter.exact.prevent
                                @keyup.enter.exact="sendMessageOnSearchInGRoomMethod"
                                @keydown.enter.shift.exact="newline" v-focus></textarea>
                        </div>
                        <div class="col-auto pl-0">
                            <button class="btn btn-primary" :disabled="!sendMessageTxt.trim()"
                                @click="sendMessageOnSearchInGRoomMethod">
                                <svg width="57px" height="54px" viewBox="1496 193 57 54" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                    style="width: 18px; height: 18px;">
                                    <g id="Group-9-Copy-3" stroke="none" stroke-width="1" fill="none"
                                        fill-rule="evenodd"
                                        transform="translate(1523.000000, 220.000000) rotate(-270.000000) translate(-1523.000000, -220.000000) translate(1499.000000, 193.000000)">
                                        <path data-v-77c07480=""
                                            d="M5.42994667,44.5306122 L16.5955554,44.5306122 L21.049938,20.423658 C21.6518463,17.1661523 26.3121212,17.1441362 26.9447801,20.3958097 L31.6405465,44.5306122 L42.5313185,44.5306122 L23.9806326,7.0871633 L5.42994667,44.5306122 Z M22.0420732,48.0757124 C21.779222,49.4982538 20.5386331,50.5306122 19.0920112,50.5306122 L1.59009899,50.5306122 C-1.20169244,50.5306122 -2.87079654,47.7697069 -1.64625638,45.2980459 L20.8461928,-0.101616237 C22.1967178,-2.8275701 25.7710778,-2.81438868 27.1150723,-0.101616237 L49.6075215,45.2980459 C50.8414042,47.7885641 49.1422456,50.5306122 46.3613062,50.5306122 L29.1679835,50.5306122 C27.7320366,50.5306122 26.4974445,49.5130766 26.2232033,48.1035608 L24.0760553,37.0678766 L22.0420732,48.0757124 Z"
                                            id="sendicon" fill="#ffffff" fill-rule="nonzero"></path>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="fixloader message_search_loader" v-if="msgSearchApiLoader">
                    <div class="spinner spinner-1"></div>
                </div>
            </div>
        </div>
        <!-- Forward Message Popup Code Here -->
        <forwardMsgPopup v-if="forwardMsgPopup" :forwardMsgInfo="forwardMsgInfo" :roomSocketUrl="roomSocketUrl"
            :chatRoomInfo="chatInfo">
        </forwardMsgPopup>
        <!-- Forward Message Popup Code Here -->
    </div>
</template>

<script>
import { bus } from '@/main';
import forwardMsgPopup from "@/components/private/workspace/forward-msg-popup/index.vue";
import currentUser from '@/mixins/currentUser'

export default {
    name: 'message-search-popup',
    directives: {
        focus: {
            inserted: function (el) {
                el.focus()
            }
        }
    },
    mixins: [currentUser],
    components: {
        forwardMsgPopup
    },
    props: {
        messageSearchForChatInfo: {
            type: Object,
            required: true
        },
        roomSocketUrl: {
            required: true,
            validator(value) {
                return value && typeof value.send === 'function';
            }
        }
    },
    data() {
        return {
            chatInfo: this.messageSearchForChatInfo,
            search_term: '',
            searchMessageData: null,
            searchMessageResults: [],
            searchMessageActionState: false,
            msgSearchApiLoader: false,
            replyOnMessageBoxState: false,
            replyOnMessageData: null,
            sendMessageTxt: '',
            replyMsgForSeletedId: '',
            forwardMsgInfo: [],
            forwardMsgPopup: false,
            searchTimer: null,
            searchRequestId: 0
        }
    },
    computed: {
       conversationName() {
            const chatInfo = this.chatInfo || {};
            const user = chatInfo.user || {};

            return (
                chatInfo.group_name ||
                chatInfo.name ||
                [user.first_name, user.last_name].filter(Boolean).join(' ')
            );
        },
    },
    mounted() {
        document.body.classList.add('body_right_scroll_remove');
        bus.$on('forwardMsgPopupBus', this.handleForwardPopupState);
    },
    beforeDestroy() {
        clearTimeout(this.searchTimer);
        bus.$off('forwardMsgPopupBus', this.handleForwardPopupState);
        document.body.classList.remove('body_right_scroll_remove');
    },
    methods: {
        isImageFile(filePath) {
            if (!filePath) return false;
            const imageExtensions = ['png', 'jpeg', 'jpg', 'svg', 'gif', 'webp'];
            const cleanPath = filePath.split('?')[0];
            const extension = cleanPath.split('.').pop().toLowerCase();
            return imageExtensions.includes(extension);
        },
        getFileName(filePath) {
            if (!filePath) return '';
            return filePath.split('/').pop().split('?')[0];
        },
        newline() { },
        /*
         * This Will Checking Chat Message Position 
         */
        getMessagePosition(chatData) {
            const senderId = chatData && chatData.sender && chatData.sender.user_id;
            return String(senderId) === String(this.selfUserId)
                ? 'sent_message_of_search'
                : 'received_message_of_search';
        },
        /*
        * This Will Message Search For Method
        */
        messageSearchFromRoomMethod() {
            clearTimeout(this.searchTimer);

            const searchTerm = this.search_term.trim();
            if (searchTerm.length < 3) {
                this.resetSearchResults();
                return;
            }

            this.searchMessageActionState = true;
            this.msgSearchApiLoader = true;
            const requestId = ++this.searchRequestId;

            this.searchTimer = setTimeout(async () => {
                try {
                    const res = await this.$store.dispatch('searchMessages', {
                        search_term: searchTerm,
                        id: this.chatInfo.chat_room
                    });

                    if (requestId !== this.searchRequestId) return;

                    const data = res && res.data && res.data.data;
                    this.searchMessageData = data || null;
                    this.searchMessageResults = data && Array.isArray(data.results)
                        ? data.results
                        : [];
                } catch (error) {
                    if (requestId === this.searchRequestId) {
                        this.searchMessageData = null;
                        this.searchMessageResults = [];
                    }
                } finally {
                    if (requestId === this.searchRequestId) {
                        this.msgSearchApiLoader = false;
                    }
                }
            }, 350);
        },
        resetSearchResults() {
            this.searchRequestId += 1;
            this.searchMessageData = null;
            this.searchMessageResults = [];
            this.searchMessageActionState = false;
            this.msgSearchApiLoader = false;
        },
        clearSearchTermAction() {
            this.search_term = '';
            clearTimeout(this.searchTimer);
            this.resetSearchResults();
        },
        searchMessagePopupCloseMethod() {
            bus.$emit('messageSearchPopupStateBus', false);
            document.body.classList.remove('body_right_scroll_remove');
        },
        replyOnMessageViewOpenMethod(msgInfo) {
            this.replyMsgForSeletedId = msgInfo.id;
            this.replyOnMessageData = msgInfo;
            this.replyOnMessageBoxState = true;
            setTimeout(() => {
                // Set the scrollTop property of the element to its scroll height
                const element = this.$el;
                if (element) element.scrollTop = element.scrollHeight + 155;
            }, 200);
        },
        replyOnMessageViewClosedMethod() {
            this.replyOnMessageData = null;
            this.replyOnMessageBoxState = false;
            this.replyMsgForSeletedId = '';
        },
        sendMessageOnSearchInGRoomMethod() {
            const content = this.sendMessageTxt.trim();
            if (!content || !this.roomSocketUrl || this.roomSocketUrl.readyState !== 1) return;

            const payload = {
                chatRoomId: this.chatInfo.id,
            };

            this.roomSocketUrl.send(JSON.stringify({
                type: 'chat_message',
                message: {
                    content,
                    reply_to: this.replyMsgForSeletedId || null,
                }
            }));

            setTimeout(() => {
                bus.$emit('newChatMessage', payload);
            }, 800);

            this.sendMessageTxt = '';
            this.searchMessagePopupCloseMethod();
        },
        forwardMsgToUserMethod(data) {
            this.forwardMsgPopup = true;
            this.forwardMsgInfo = [data];
        },
        handleForwardPopupState(state) {
            this.forwardMsgPopup = state;
            if (!state) this.forwardMsgInfo = [];
        }
    },
    watch: {
        search_term() {
            this.messageSearchFromRoomMethod();
        },
        messageSearchForChatInfo: {
            handler(value) {
                this.chatInfo = value;
                this.clearSearchTermAction();
            },
            deep: false
        }
    }
}
</script>

<style lang="scss" scoped>
.message_search_popup_main {
    position: fixed;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.92);
    left: 0;
    right: 0;
    z-index: 1000000;
    padding: 40px 0px 0px;
    overflow-y: auto;

    .message_search_modal {
        background: #000;
        width: 100%;
        margin: 0px auto;
        border-radius: 5px;
        padding: 20px;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        color: #ffffff;
        -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        max-width: 540px;
        position: relative;
    }

    .message_search_modal_header {
        .message_searchbar {
            position: relative;
            background: none;
            border-radius: 80px;
            padding: 0;
            border: 3px solid rgba(255, 255, 255, 0.15);

            .search_icon {
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
            }

            .form-control {
                background: none;
                border: none;
                color: #ffffff;
                padding: 8px 45px;
                height: auto;
                font-size: 16px;
                outline: none;
                -webkit-box-shadow: none;
                box-shadow: none;
                color: #ffd400;
            }

            .back_icon {
                position: absolute;
                left: 10px;
                top: 50%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                cursor: pointer;
            }

            &.active {
                border: 3px solid #ffd400;
            }

            .x-alt {
                position: absolute;
                right: 15px;
                top: 45%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                cursor: pointer;

                svg:hover path {
                    fill: #87cefa;
                }
            }
        }

        .message_search_modal_heading {
            font-size: 24px;
            margin-bottom: 15px;
        }

        .close_modal_search {
            position: absolute;
            top: 5px;
            right: 5px;
            line-height: 1;

            .fa {
                font-size: 22px;
                color: #e4002b;
                cursor: pointer;
                transform: scale(1);
                -webkit-transform: scale(1);
                -moz-transform: scale(1);
                -webkit-transition: all ease 0.5s;
                transition: all ease 0.5s;

                &:hover {
                    color: #87cefa;
                }
            }
        }
    }

    .message_search_modal_body {
        position: relative;
        min-height: 140px;

        .message_list_items {
            background: rgba(255, 255, 255, 0.04);
            padding: 10px;
            border-radius: 3px;
            margin: 0px;
        }

        .message_list_item {
            .message_list_item_inner {
                padding: 5px 8px;
                line-height: 1.3;
                margin: 0 0 8px;
                word-break: break-word;
                white-space: normal;
                position: relative;
                font-weight: 500;
                border-radius: 7px;
                font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;

                &.sent_message_of_search {
                    background: #ffb6c1;
                }

                &.received_message_of_search {
                    background: #b1d4e5;
                }
            }

            &:last-child {
                .message_list_item_inner {
                    margin-bottom: 0px;
                }
            }

            .mesg_text {
                font-size: 14px;
                color: #000;
            }

            .msg_time {
                font-size: 10px;
                line-height: 1;
                margin-top: 5px;
                font-weight: 500;
                color: rgba(0, 0, 0, 0.5);
            }

            .dropdown {
                position: absolute;
                right: 5px;
                top: 5px;

                .fa-chevron-down {
                    cursor: pointer;
                    color: #000000;
                }

                .dropdown-menu {
                    padding: 5px 0px;
                    margin: 0px;
                    background-color: rgba(0, 0, 0, 0.92);
                    border: 1px solid rgba(255, 255, 255, 0.15);

                    li {
                        padding: 5px 10px;
                        color: #ffffff;
                        font-size: 14px;
                        line-height: 1.3;
                        letter-spacing: 0.5px;
                        cursor: pointer;

                        &:hover {
                            color: #ffd400;
                        }
                    }
                }
            }

            .form-control {
                font-family: "proxima-nova", "Source Sans Pro", sans-serif;
                float: left;
                border: none;
                width: calc(100% - 50px);
                padding: 10px 22px;
                font-size: 15px;
                color: #fff;
                background: #111;
                line-height: 1.3;
                height: 90px;
                outline: none;
                resize: none;
                -ms-overflow-style: none;
                overflow: -moz-scrollbars-none;
            }
        }

        .rply_textbox_wrp {
            background: #111;
            padding-left: 15px;
            margin-top: 10px;
            border-radius: 5px;

            .reply_msg_detail_view_wrp {
                padding: 5px 15px 0px 0px;
            }

            .reply_msg_data_wrp {
                background: #232323;
                padding: 5px 10px;
                border-radius: 5px;
                border-left: 3px solid #87cefa;
            }

            .x-alt {
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                cursor: pointer;

                svg:hover path {
                    fill: #87cefa;
                }
            }

            .form-control {
                font-family: "proxima-nova", "Source Sans Pro", sans-serif;
                padding: 10px 0px;
                font-size: 14px;
                color: #fff;
                background: #111;
                line-height: 1.3;
                height: 90px;
                outline: none;
                resize: none;
                border: none;
                box-shadow: none;
            }

            .btn-primary {
                border: none;
                width: 50px;
                cursor: pointer;
                background: #232323;
                color: #ffffff;
                height: 100%;
                border-radius: 0px;
                box-shadow: none !important;
                outline: none !important;

                &:hover {
                    background: #87cefa;

                    path {
                        fill: #000000;
                    }
                }
            }
        }
    }
}
</style>